import { createContext } from 'react';
import { MFA_TYPE } from '@common/types';

interface IMFAContext {
  step: number;
  goToNextStep: () => void;
  goToFirstStep: () => void;
  goToPreviousStep: () => void;
  mfaType: MFA_TYPE;
  setMFAType: (type: MFA_TYPE) => void;
}

export const MFAContext = createContext<IMFAContext>({
  step: 0,
  goToNextStep: () => undefined,
  goToPreviousStep: () => undefined,
  goToFirstStep: () => undefined,
  mfaType: MFA_TYPE.APP,
  setMFAType: () => undefined,
});
